var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { AccountPopupsEnum, ELoginPopupState, accTypes, } from "../constant";
import { Col } from "react-bootstrap";
import { EServiceRequest, SRRedirectionUrl, } from "@frameworks/web/components/features/ServiceRequest/constant";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import React, { useEffect, useRef, useState } from "react";
import _, { reject } from "underscore";
import AccountsPopups from "../AccountsPopups";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import EditProfile from "./EditProfile";
import Editicon from "@frameworks/web/assets/images/features/BasicProfile/Editicon.svg";
import InfinityBannerProfile from "@frameworks/web/assets/images/features/BasicProfile/InfinityBannerProfile.png";
import PopupWatchlist from "@frameworks/web/components/features/WatchList/CommonWatchlist/PopupWatchlist";
import RefreshLabel from "@frameworks/web/components/generic/CountInput/RefreshLabel";
import ThreeDotLoader from "@frameworks/web/components/generic/ThreeDotLoader";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import { accountDetails } from "@mainDi/webDi";
import bannerimg from "@frameworks/web/assets/images/features/BasicProfile/banner-img.png";
import di from "../di/servicelocator";
import { getImageString } from "@frameworks/web/utils/base64_functions";
import { navigateSelf } from "@frameworks/web/components/features/ServiceRequest/ServiceRequest";
import profileimg from "@frameworks/web/assets/images/features/BasicProfile/profile-icon.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
var ProfileData = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
    var device = DeviceContext();
    var navigate = useNavigate();
    var canvasRef = useRef(null);
    // const [capturedImage, setCapturedImage] = useState<string | null>(null);
    var _19 = __read(React.useState(false), 2), showToast = _19[0], setShowToast = _19[1];
    var _20 = __read(React.useState(""), 2), toastMsg = _20[0], setToastMsg = _20[1];
    var videoRef = useRef(null);
    var _21 = __read(useState(false), 2), streamStarted = _21[0], setStreamStarted = _21[1];
    var _22 = __read(useState(false), 2), isCanOpen = _22[0], setIsCanOpen = _22[1];
    var _23 = __read(useState(false), 2), editProfile = _23[0], seteditProfile = _23[1];
    var _24 = __read(useState(AccountPopupsEnum.DEFAULT), 2), screenState = _24[0], setScreenState = _24[1];
    var _25 = __read(useState({
        accType: "",
        mergeStatus: "",
    }), 2), accountState = _25[0], setAccountState = _25[1];
    var _26 = __read(useState(), 2), toggledAcc = _26[0], settoggledAcc = _26[1];
    var _27 = __read(useState(false), 2), isHovered = _27[0], setIsHovered = _27[1];
    var _28 = __read(React.useState({ isOpen: false, errMsg: null }), 2), errMsg = _28[0], setErrMsg = _28[1];
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var _29 = __read(useState(bannerimg), 2), image = _29[0], setimage = _29[1];
    var _30 = __read(useState(InfinityBannerProfile), 2), image2 = _30[0], setImage2 = _30[1];
    var _31 = __read(useState(undefined), 2), stream = _31[0], setstream = _31[1];
    var _32 = __read(useState(false), 2), cameraPermissionDenied = _32[0], setCameraPermissionDenied = _32[1];
    var _33 = __read(useState(false), 2), isInfinity = _33[0], setIsInfinity = _33[1];
    var _34 = __read(useState(undefined), 2), nriDetails = _34[0], setNRIDetails = _34[1];
    var _35 = __read(useState(false), 2), loader = _35[0], setLoader = _35[1];
    var _36 = __read(React.useState(false), 2), errMessage = _36[0], setErrMessage = _36[1];
    var _37 = __read(useState(undefined), 2), imageDataURL = _37[0], setImageDataURL = _37[1];
    var accountsData = useSelector(function (state) { return state.LoginFlow.ClientLoginDataReducers; }, _.isEqual).data;
    var getNRIDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    payload = (_a.accTyp = (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.accTyp,
                        _a);
                    setLoader(true);
                    di.basicProfile
                        .getClientcategoryNRI(payload)
                        .then(function (result) {
                        var _a;
                        if (result) {
                            setNRIDetails(eval(JSON.parse(JSON.stringify((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.value))));
                            setLoader(false);
                            setequitycommodityCheck();
                        }
                    })
                        .catch(function (error) {
                        setLoader(false);
                        setErrMessage(true);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var getprofilepicDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, accCode, accTyp, payload;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                    payload = { acCode: accCode };
                    di.basicProfile.getProfilePicData(payload);
                    return [2 /*return*/];
            }
        });
    }); };
    var getallprofilepicDetails = useSelector(function (state) { return state.BasicProfile.GetProfilePicReducer; }
    // _.isEqual
    );
    var getprofiledatauserid = (_a = getallprofilepicDetails === null || getallprofilepicDetails === void 0 ? void 0 : getallprofilepicDetails.data) === null || _a === void 0 ? void 0 : _a.userId;
    useEffect(function () {
        var getImage = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getmfInf().then(function (val) {
                    if (val) {
                        val && setimage(bannerimg);
                    }
                    else {
                        val && setImage2(InfinityBannerProfile);
                    }
                }).catch(function (err) {
                    reject(err);
                });
                return [2 /*return*/];
            });
        }); };
        getImage();
    }, []);
    // const checkcommodity = async () => {
    //   if (
    //     props.mrgSts === ELoginPopupState.NOT_ENABLED &&
    //     (props.acc_type === "CO" || props.acc_type === "EQ")
    //   ) {
    //     localStorage.clear();
    //     navigate("/login");
    //     window.location.reload();
    //   } else if (props.acc_type === "COMEQ") {
    //     if (props.mrgSts === ELoginPopupState.COMPLETED) {
    //       props.settoggledAcc(props.toggledAcc === "EQ" ? "CO" : "EQ");
    //     } else {
    //       localStorage.clear();
    //       navigate("/login");
    //       window.location.reload();
    //     }
    //   } else {
    //     setopenAccount(true);
    //   }
    // };
    // const setequitycommodityCheck = async () => {
    //   if (
    //     props.mrgSts === ELoginPopupState.NOT_ENABLED &&
    //     (props.acc_type === "CO" || props.acc_type === "EQ")
    //   ) {
    //     setequitycommodity(true);
    //   } else if (props.acc_type === "COMEQ") {
    //     if (props.mrgSts === ELoginPopupState.COMPLETED) {
    //       props.settoggledAcc(props.toggledAcc === "EQ" ? "CO" : "EQ");
    //     } else {
    //       setequitycommodity(true);
    //     }
    //   } else {
    //     setopenAccount(true);
    //   }
    // };
    var setequitycommodityCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var temp;
        var _a, _b;
        return __generator(this, function (_c) {
            if (((_b = (_a = nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.AccountCategory) === "NRI") {
                setScreenState(AccountPopupsEnum.NRI_ACCOUNT);
            }
            else {
                if (accountState.mergeStatus === ELoginPopupState.NOT_ENABLED &&
                    (accountState.accType === "CO" || accountState.accType === "EQ")) {
                    setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                }
                else if (accountState.accType === "COMEQ") {
                    // setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                    if (accountState.mergeStatus === "COMPLETED") {
                        temp = accData;
                        temp.prefAccTyp = accData.prefAccTyp === "EQ" ? "CO" : "EQ";
                        localStorage.setItem("acc_data", JSON.stringify(temp));
                        location === null || location === void 0 ? void 0 : location.reload();
                    }
                    else {
                        setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                    }
                }
                else {
                    setScreenState(AccountPopupsEnum.NEW_ACCOUNT);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var dobString = ((_b = props === null || props === void 0 ? void 0 : props.clientlist) === null || _b === void 0 ? void 0 : _b.clientDob) || "-";
    var dobDate = new Date(dobString);
    var day = dobDate.getDate();
    var month = dobDate.getMonth() + 1;
    var year = dobDate.getFullYear();
    var formattedDOB = "".concat(month, "-").concat(day, "-").concat(year);
    React.useEffect(function () {
        var accData = {
            accType: "",
            mergeStatus: "",
        };
        accountDetails.getAccTyp().then(function (x) {
            accData.accType = x;
            if (x === "COMEQ") {
                accountDetails.prefAccTyp().then(function (y) {
                    if (y === undefined) {
                        settoggledAcc("EQ");
                    }
                    else {
                        settoggledAcc(y);
                    }
                });
            }
        });
        accountDetails
            .getAccountMrgSts()
            .then(function (x) {
            accData.mergeStatus = x;
            setAccountState({
                accType: accData.accType,
                mergeStatus: x,
            });
        })
            .catch(function (err) {
            reject(err);
        });
        var getInfinityAcc = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getmfInf().then(function (isInfinity) {
                    isInfinity && setIsInfinity(true);
                }).catch(function (err) {
                    reject(err);
                });
                return [2 /*return*/];
            });
        }); };
        getInfinityAcc();
    }, []);
    useEffect(function () {
        if (!isCanOpen) {
            setImageDataURL(undefined);
        }
    }, [isCanOpen]);
    var handleMouseEnter = function () {
        setIsHovered(true);
    };
    var handleMouseLeave = function () {
        setIsHovered(false);
    };
    // const openNewAccount = async () => {
    //   setopenAccount(false);
    //   setLoader(true);
    //   if (props.mrgSts === ELoginPopupState.ONE_ACCOUNT) {
    //     const eqName = await accountDetails.getEqAccName();
    //     const email = await accountDetails.getEmailId();
    //     const coAccName = await accountDetails.getCoAccName();
    //     const phone = await accountDetails.getAccPhoneNo();
    //     const payload = {
    //       name: eqName,
    //       email: email,
    //       productNames: props.acc_type === "CO" ? "Commodity" : "Equity",
    //       productPage: "EWINNONCLIENT",
    //       Phone: phone,
    //     };
    //     setLoader(true);
    //     await di.basicProfile
    //       .saveLeadData(payload)
    //       .then((data) => {
    //         setLoader(false);
    //         if (data && data.data) {
    //           setopenAccount(false);
    //           setLoader(false);
    //           setSuccessPopUp(true);
    //         }
    //       })
    //       .catch((error) => {
    //         setopenAccount(false);
    //         setLoader(false);
    //         setFailurePopUp(true);
    //         setErrMsg({ isOpen: true, errMsg: error });
    //       });
    //   }
    // };
    // const stopCamera = () => {
    //   const stream = videoRef.current.srcObject;
    //   const tracks = (stream as any).getTracks();
    //   tracks.forEach((track:any) => {
    //     track.stop();
    //   });
    //   videoRef.current.srcObject = null;
    //   setStreamStarted(false);
    // };
    var startStream = function () { return __awaiter(void 0, void 0, void 0, function () {
        var constraints, str, videoElement, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    constraints = {
                        video: true, // You can add additional constraints here if needed
                    };
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
                case 1:
                    str = _a.sent();
                    setstream(str);
                    if (videoRef.current && str instanceof MediaStream) {
                        videoElement = videoRef.current;
                        if (videoElement) {
                            videoElement.srcObject = str;
                            setStreamStarted(true);
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    reject(error_1);
                    if (error_1.name === "NotAllowedError") {
                        setCameraPermissionDenied(true);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var stopStream = function () {
        // const stream = videoRef.current?.srcObject as MediaStream;
        if (stream) {
            var tracks = stream.getTracks();
            tracks.forEach(function (track) { return track.stop(); });
            setStreamStarted(false);
            setstream(undefined);
        }
    };
    var toggleStream = function () {
        if (streamStarted) {
            stopStream();
        }
        else {
            startStream();
        }
    };
    var captureImage = function () {
        var _a;
        if (imageDataURL) {
            startStream();
            setImageDataURL(undefined);
        }
        else {
            if (videoRef.current && canvasRef.current && isCanOpen) {
                var canvas = canvasRef.current;
                var video = videoRef.current;
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                (_a = canvas
                    .getContext("2d")) === null || _a === void 0 ? void 0 : _a.drawImage(video, 0, 0, canvas.width, canvas.height);
                var capturedDataURL = canvas.toDataURL("image/png");
                setImageDataURL(capturedDataURL);
                stopStream();
            }
        }
    };
    // useEffect(() => {
    //   captureImage();
    // }, [videoRef, canvasRef, isCanOpen]);
    var handleImageSubmission = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, accCode, accTyp, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!imageDataURL) {
                        console.error("No image captured");
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 2:
                    _a = _b.sent(), accCode = _a.accCode, accTyp = _a.accTyp;
                    return [4 /*yield*/, di.basicProfile.SaveProfilePicData({
                            savepicbody: {
                                userId: getprofiledatauserid,
                                accountCode: accCode,
                                profileImageByte: imageDataURL.split(",")[1],
                                imageName: "captured.png",
                            },
                        })];
                case 3:
                    _b.sent();
                    getprofilepicDetails();
                    setShowToast(true);
                    setToastMsg("Upload Successfully");
                    seteditProfile(false);
                    setIsCanOpen(false);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _b.sent();
                    reject(err_1);
                    setShowToast(true);
                    setToastMsg("Something went wrong");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        ((_d = (_c = props.clientdatalist) === null || _c === void 0 ? void 0 : _c.client) === null || _d === void 0 ? void 0 : _d.active) === "0" ? (React.createElement("div", { className: "DMSanM_14_500 txt_bloodRed suspended-account" },
            "Your account has been suspended.",
            " ",
            React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1" }, "Please contact your RM for further information."))) : null,
        React.createElement(React.Fragment, null,
            device && device.isDesktop ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "profile-outer-box" },
                    React.createElement(Col, { lg: 12, className: "px-0" },
                        React.createElement("div", { className: "profile" },
                            React.createElement("div", { className: "profile-header" },
                                isInfinity ? (React.createElement("img", { src: image2, alt: "Infinity Account Image", className: "infinity-account-desk" })) : (React.createElement("img", { className: "profile-backround-img", src: image, alt: "Regular Account Image" })),
                                React.createElement("div", { className: "profile-header-content" },
                                    React.createElement("div", { className: "profile-header-img", onClick: function () { return seteditProfile(true); } },
                                        React.createElement("img", { src: getImageString((_f = (_e = props.getallprofilepicDetails) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.profileImageByte) !== ""
                                                ? getImageString((_h = (_g = props.getallprofilepicDetails) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.profileImageByte)
                                                : profileimg }),
                                        React.createElement("span", { className: "Editicon-div" },
                                            React.createElement("i", { className: "edel-icon-edit" }))),
                                    React.createElement("div", { className: "d-flex justify-content-end me-5 pt-15-top" }, loader ? (React.createElement(React.Fragment, null,
                                        React.createElement(ThreeDotLoader, null),
                                        " ")) : (React.createElement(React.Fragment, null,
                                        React.createElement(RefreshLabel, { title: props.acc_type !== "COMEQ"
                                                ? accTypes[props.acc_type]
                                                : accTypes[props.toggledAcc], icon: true, parentClassName: "Equity-profile-btn", onCallBackFunction: function () {
                                                getNRIDetails();
                                            } })))))))),
                    ((_j = props === null || props === void 0 ? void 0 : props.errorAllClientDetails) === null || _j === void 0 ? void 0 : _j.isOpen) ? (React.createElement(React.Fragment, null,
                        React.createElement(ErrorNotification, { error: (_k = props === null || props === void 0 ? void 0 : props.errorAllClientDetails) === null || _k === void 0 ? void 0 : _k.error, isOpen: (_l = props === null || props === void 0 ? void 0 : props.errorAllClientDetails) === null || _l === void 0 ? void 0 : _l.isOpen, displayType: ErrorDisplayType.INSECTION }))) : (React.createElement(React.Fragment, null,
                        React.createElement(Col, { lg: 12, className: "px-30" },
                            React.createElement("div", { className: "d-flex" },
                                React.createElement("div", { className: "DMSansBold_20_700 txt_blackOne1 " }, (_m = props === null || props === void 0 ? void 0 : props.clientlist) === null || _m === void 0 ? void 0 : _m.accName),
                                React.createElement("div", { className: "basic-profile-circle imCircle d-flex align-content-center" }),
                                React.createElement("div", { className: "DMSansMedium_16_500 txt_primaryGrey basicprofile-changes" }, "ID"),
                                React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 ps-2 basicprofile-changes" }, ((_o = props.clientlist) === null || _o === void 0 ? void 0 : _o.acCode) !== null
                                    ? (_p = props.clientlist) === null || _p === void 0 ? void 0 : _p.acCode
                                    : "-"))),
                        React.createElement(Col, { lg: 12, className: "grid-3-full px-30 mgt-30 " },
                            React.createElement("span", { className: "text-left" },
                                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "PAN"),
                                React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2" }, ((_q = props.clientlist) === null || _q === void 0 ? void 0 : _q.panNumber)
                                    ? (_r = props.clientlist) === null || _r === void 0 ? void 0 : _r.panNumber
                                    : "-")),
                            React.createElement("span", { className: "text-left" },
                                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Mobile Number"),
                                React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2" }, ((_s = props.clientlist) === null || _s === void 0 ? void 0 : _s.mobileNo)
                                    ? (_t = props.clientlist) === null || _t === void 0 ? void 0 : _t.mobileNo
                                    : "-"),
                                React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img hand_cursor", onClick: function () {
                                        return navigateSelf(SRRedirectionUrl[EServiceRequest.EMAILPHONE]);
                                    } },
                                    React.createElement("img", { src: Editicon }),
                                    " Edit")),
                            React.createElement("div", { className: "text-left overflow-hidden d-flex" },
                                React.createElement("div", { className: "DMSanN_16_400 txt_primaryGrey " }, "Email ID"),
                                ((_u = props.clientlist) === null || _u === void 0 ? void 0 : _u.email) ? (React.createElement("div", { className: "d-flex" },
                                    React.createElement("div", { className: "DMSans_16_500 txt_blackOne1 ps-2 email-component textOverflow-max100", title: (_v = props.clientlist) === null || _v === void 0 ? void 0 : _v.email }, (_w = props.clientlist) === null || _w === void 0 ? void 0 : _w.email),
                                    React.createElement("div", { className: "DMSansMedium_12_500 Editicon-img  hand_cursor", onClick: function () {
                                            return navigateSelf(SRRedirectionUrl[EServiceRequest.EMAILPHONE]);
                                        } },
                                        React.createElement("img", { src: Editicon }),
                                        " Edit"))) : (React.createElement("span", { className: "mgl-5" }, "-")))),
                        React.createElement(Col, { lg: 12, className: "grid-3-full px-30 mgt-30 pb-4" },
                            React.createElement("span", { className: "text-left" },
                                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Correspondence Address"),
                                ((_x = props === null || props === void 0 ? void 0 : props.clientlist) === null || _x === void 0 ? void 0 : _x.correspondenceAddress) ? (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img hand_cursor", onClick: function () {
                                            return navigateSelf(SRRedirectionUrl[EServiceRequest.ADDRESS]);
                                        } },
                                        React.createElement("img", { src: Editicon }),
                                        " Edit"),
                                    React.createElement("span", { className: "d-flex " }, (_y = props === null || props === void 0 ? void 0 : props.clientlist) === null || _y === void 0 ? void 0 : _y.correspondenceAddress))) : (React.createElement("span", { className: "mgl-5" }, "-"))),
                            React.createElement("span", { className: "text-left" },
                                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Permanent Address"),
                                ((_z = props === null || props === void 0 ? void 0 : props.clientlist) === null || _z === void 0 ? void 0 : _z.residenceAddress) ? (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img hand_cursor", onClick: function () {
                                            return navigateSelf(SRRedirectionUrl[EServiceRequest.ADDRESS]);
                                        } },
                                        React.createElement("img", { src: Editicon }),
                                        " Edit"),
                                    React.createElement("span", { className: "d-flex " }, (_0 = props === null || props === void 0 ? void 0 : props.clientlist) === null || _0 === void 0 ? void 0 : _0.residenceAddress))) : (React.createElement("span", { className: "mgl-5" }, "-"))),
                            React.createElement("span", { className: "text-left" },
                                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Date of Birth"),
                                React.createElement("span", { className: "DMSans_16_500 txt_blackOne1 ps-2 pe-2" }, dobString !== "-" ? formattedDOB : "-")))))),
                ((_2 = (_1 = nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data) === null || _1 === void 0 ? void 0 : _1.value) === null || _2 === void 0 ? void 0 : _2.AccountCategory) === "NRI" ? (React.createElement("div", { className: "profiledata-popup" },
                    React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "NRI Account", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: screenState === AccountPopupsEnum.NRI_ACCOUNT, setShow: function () {
                            setequitycommodityCheck();
                        }, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, nriDetails: nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data, btnvalueleft: screenState === AccountPopupsEnum.NRI_ACCOUNT
                                ? {
                                    value: "Back",
                                    btnTyp: "midnight-blue-border",
                                    className: "",
                                }
                                : null }) }))) : (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("div", { className: "profiledata-popup" },
                        React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "Switch account type", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: screenState !== AccountPopupsEnum.DEFAULT, setShow: function () { return setScreenState(AccountPopupsEnum.DEFAULT); }, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, nriDetails: nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data, btnvalueleft: screenState === AccountPopupsEnum.NEW_ACCOUNT
                                    ? {
                                        value: "No, thanks",
                                        btnTyp: "midnight-blue-border",
                                        className: "",
                                    }
                                    : screenState ===
                                        AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                        ? {
                                            value: "Cancel",
                                            btnTyp: "midnight-blue-border",
                                            className: "",
                                        }
                                        : screenState === AccountPopupsEnum.SUCCESS_RESULT
                                            ? {
                                                value: "Ok, Got it",
                                                btnTyp: "midnight-blue-border",
                                                onClick: function () {
                                                    return setScreenState(AccountPopupsEnum.DEFAULT);
                                                },
                                            }
                                            : null, btnvalueright: screenState === AccountPopupsEnum.NEW_ACCOUNT
                                    ? {
                                        value: "Yes, right away",
                                        btnTyp: "midnight-blue",
                                        className: "",
                                    }
                                    : screenState ===
                                        AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                        ? {
                                            value: "Yes",
                                            btnTyp: "midnight-blue",
                                            className: "",
                                        }
                                        : null }) })))))) : (React.createElement(React.Fragment, null,
                React.createElement(Col, { lg: 12, className: "DMSansNormal_20_400 pb-4" },
                    React.createElement("span", { className: "d-flex align-items-center mb-title", onClick: function () {
                            navigate("/profile");
                        } },
                        React.createElement("i", { className: "edel-icon-arrow-left1 pe-2" }),
                        "My \u00A0",
                        React.createElement("strong", null, "Details"))),
                React.createElement("div", { className: "border-outer-box p-3" },
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Name"),
                        React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex" }, ((_3 = props.clientlist) === null || _3 === void 0 ? void 0 : _3.accName) ? (_4 = props.clientlist) === null || _4 === void 0 ? void 0 : _4.accName : "-")),
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3 pt-3" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "PAN"),
                        React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex" }, ((_5 = props.clientlist) === null || _5 === void 0 ? void 0 : _5.panNumber)
                            ? (_6 = props.clientlist) === null || _6 === void 0 ? void 0 : _6.panNumber
                            : "-")),
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3 pt-3" },
                        React.createElement("div", { className: "grid-2" },
                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Mobile Number"),
                            ((_7 = props.clientlist) === null || _7 === void 0 ? void 0 : _7.mobileNo) && (React.createElement(React.Fragment, null,
                                React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img text-right", onClick: function () {
                                        return navigateSelf(SRRedirectionUrl[EServiceRequest.EMAILPHONE]);
                                    } },
                                    React.createElement("img", { src: Editicon }),
                                    " Edit")))),
                        ((_8 = props.clientlist) === null || _8 === void 0 ? void 0 : _8.mobileNo) ? (React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex" }, (_9 = props.clientlist) === null || _9 === void 0 ? void 0 : _9.mobileNo)) : ("-")),
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3 pt-3" },
                        React.createElement("div", { className: "grid-2" },
                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Email Id"),
                            ((_10 = props.clientlist) === null || _10 === void 0 ? void 0 : _10.email) && (React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img text-right", onClick: function () {
                                    return navigateSelf(SRRedirectionUrl[EServiceRequest.EMAILPHONE]);
                                } },
                                React.createElement("img", { src: Editicon }),
                                " Edit"))),
                        ((_11 = props.clientlist) === null || _11 === void 0 ? void 0 : _11.email) ? (React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex" }, (_12 = props.clientlist) === null || _12 === void 0 ? void 0 : _12.email)) : ("-")),
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3 pt-3" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Date of birth"),
                        React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex" }, dobString !== "-" ? formattedDOB : "-")),
                    React.createElement(Col, { lg: 12, className: "brd-bottom pb-3 pt-3" },
                        React.createElement("div", { className: "grid-2" },
                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Correspondence Address"),
                            ((_13 = props.clientlist) === null || _13 === void 0 ? void 0 : _13.correspondenceAddress) && (React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img text-right", onClick: function () {
                                    return navigateSelf(SRRedirectionUrl[EServiceRequest.ADDRESS]);
                                } },
                                React.createElement("img", { src: Editicon }),
                                " Edit"))),
                        React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex address-basicprofile" }, ((_14 = props.clientlist) === null || _14 === void 0 ? void 0 : _14.correspondenceAddress)
                            ? (_15 = props.clientlist) === null || _15 === void 0 ? void 0 : _15.correspondenceAddress
                            : "-")),
                    React.createElement(Col, { lg: 12, className: "pb-3 pt-3" },
                        React.createElement("div", { className: "grid-2" },
                            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey d-flex" }, "Permanent Address"),
                            ((_16 = props.clientlist) === null || _16 === void 0 ? void 0 : _16.residenceAddress) && (React.createElement("span", { className: "DMSansMedium_12_500 Editicon-img text-right ", onClick: function () {
                                    return navigateSelf(SRRedirectionUrl[EServiceRequest.ADDRESS]);
                                } },
                                React.createElement("img", { src: Editicon }),
                                " Edit"))),
                        React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1 mt-2 d-flex address-basicprofile" }, ((_17 = props.clientlist) === null || _17 === void 0 ? void 0 : _17.residenceAddress)
                            ? (_18 = props.clientlist) === null || _18 === void 0 ? void 0 : _18.residenceAddress
                            : "-"))))),
            editProfile && (React.createElement(React.Fragment, null,
                React.createElement(PopupWatchlist, { size: "modal-lg-660  modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist bold-heading editprofile-modal commonmodal pt-3 pb-3", title: "Edit Photo", showFooter: false, show: editProfile, setShow: seteditProfile, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(React.Fragment, null,
                        React.createElement(EditProfile, { isCanOpen: isCanOpen, setIsCanOpen: setIsCanOpen, seteditProfile: seteditProfile, videoRef: videoRef, streamStarted: false, setStreamStarted: setStreamStarted, setShowToast: setShowToast, setToastMsg: setToastMsg, getprofiledatauserid: getprofiledatauserid, canvasRef: canvasRef, showToast: showToast, toastMsg: toastMsg, toggleStream: toggleStream })) }))),
            cameraPermissionDenied && (React.createElement("div", null,
                React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "Permission Denied", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: cameraPermissionDenied, setShow: setCameraPermissionDenied, showCloseIcon: true, closeicon: "edel-icon-bold-close", closeDropdown: function () {
                        setIsCanOpen(false);
                        seteditProfile(false);
                    }, children: React.createElement("div", { className: "mb-30 mt-30" }, "Camera permission denied. Please allow access to your camera in your browser settings.") }))),
            isCanOpen && !cameraPermissionDenied && (React.createElement(React.Fragment, null,
                React.createElement(PopupWatchlist, { size: "modal-lg-660  modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist bold-heading editprofile-modal commonmodal pt-3 pb-3", title: React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "d-flex gap-4" },
                            React.createElement("i", { className: "edel-icon-arrow-left1 icon-left-click-pic", onClick: function () {
                                    setIsCanOpen(false);
                                    seteditProfile(true);
                                    toggleStream();
                                } }),
                            React.createElement("div", null, "Click Photo"))), showFooter: false, show: isCanOpen, setShow: setIsCanOpen, showCloseIcon: true, closeDropdown: function () {
                        setIsCanOpen(false);
                        seteditProfile(true);
                        toggleStream();
                    }, closeicon: "edel-icon-bold-close", children: React.createElement(React.Fragment, null,
                        React.createElement("canvas", { ref: canvasRef, style: { display: "none" } }),
                        imageDataURL ? (React.createElement("div", null,
                            React.createElement("img", { src: imageDataURL, alt: "Captured", className: "captured-img-basic-profile" }))) : (React.createElement("video", { ref: videoRef, autoPlay: true, playsInline: true, muted: !streamStarted })),
                        React.createElement("div", { className: "d-flex justify-content-between mt-10 mb-10 gap-30 capture-and-submit" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-border", className: "alert-modal-button px-0", value: imageDataURL ? "Capture again" : "Capture", onClick: captureImage }),
                            React.createElement(EdButton, { btnTyp: "midnight-blue", className: "alert-modal-button px-0", value: "submit", onClick: handleImageSubmission, disabled: !imageDataURL })),
                        React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: showToast, setShow: setShowToast, position: "middle-center", message: toastMsg })) })))),
        errMessage && (React.createElement(React.Fragment, null,
            React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: errMessage, setShow: setErrMessage, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement("div", { className: "mb-30 mt-30" }, "Something went wrong! Please try after sometime.") }))),
        React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: showToast, setShow: setShowToast, position: "middle-center", message: toastMsg })));
};
export default ProfileData;
